import { Card } from '@/components/ui/card';
// import useGoToDeal from '@/hooks/use-go-to-deal';
import { CurrencyInput } from '@/components/ui/currency-input';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { toast } from '@/hooks/use-toast';
import { centsToInitialValue } from '@/lib/currency';
import getSerialNumberFromVin from '@/lib/get-serial-number-from-vin';

import type { Trade } from '@/models/registry';
import { useRouter } from '@tanstack/react-router';
import { BadgeInfo } from 'lucide-react';
import TradeCurrentLocationBadge from '../location/trade-current-location-badge';
import { TradeStatusSelector } from '../status/trade-status-selector';

const TradeInAppraisalCard = ({ trade }: { trade: Trade }) => {
  // const assignedTasks = trade.assigned_tasks || [];

  // const { goToDeal } = useGoToDeal();

  const router = useRouter();

  const tradeInAppraisalShortId = `TIA-${trade.short_id.split('-')[1]}`;

  return (
    <div className="w-96">
      <Card>
        <a
          // UX NOTE: This need to be a link otherwise cmd+click to open in new tab
          // will not work, and that's important for user's workflow
          className="flex flex-row items-center gap-2 px-4 py-2 hover:bg-gray-100 justify-between"
          onClick={() => {
            router.navigate({
              to: '/trade/$shortId',
              params: {
                shortId: tradeInAppraisalShortId,
              },
            });
            // goToDeal({
            //   dealShortId: deal.short_id,
            //   isForInbox: false,
            // });
          }}
          // TODO (jimmy): make this a informative link
          // href={`/${hubPathIdentifier}/deal/${deal.short_id}`}
        >
          <div className="flex flex-col items-center gap-2 w-full">
            <div className="flex flex-row items-start gap-2 justify-between w-full">
              <div className="flex flex-col justify-start gap-1 w-full">
                <div className="flex flex-row items-center gap-2 justify-between w-full text-sm">
                  <div className="">{tradeInAppraisalShortId}</div>
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div
                        className="text-nowrap overflow-hidden text-ellipsis cursor-pointer"
                        onClick={(e) => {
                          navigator.clipboard.writeText(trade.vin || '');
                          e.stopPropagation();
                          e.preventDefault();

                          toast({
                            description: (
                              <div className="flex flex-row gap-2 items-center">
                                <BadgeInfo className="size-4" />
                                <p>VIN copied to clipboard</p>
                              </div>
                            ),
                          });
                        }}
                      >
                        {getSerialNumberFromVin(trade.vin)}
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>{trade.vin}</TooltipContent>
                  </Tooltip>
                </div>
                <div className="flex flex-row items-center gap-2">
                  <div
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                    }}
                    className="flex"
                  >
                    {/* <DealStatusSelector
                      id={deal.id}
                      shortId={deal.short_id}
                      value={deal.status}
                      hideCopy
                      side="right"
                    /> */}
                    <TradeStatusSelector
                      id={trade.id}
                      value={trade.status}
                      hideCopy
                      side="right"
                    />
                    {/* <TradeStatusBadge
                      value={trade.status}
                      hideCopy
                      // buttonRef={buttonRef}
                      className="size-4"
                      buttonVariant="ghost"
                    /> */}
                  </div>

                  <div className="text-nowrap overflow-hidden w-full text-ellipsis">
                    {trade.full_name}
                  </div>
                  <div className="flex flex-row items-center justify-end">
                    {trade.resell_type}
                  </div>
                </div>
              </div>

              <div
                className="flex flex-col items-center gap-0 text-nowrap overflow-hidden text-ellipsis justify-end"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                {/* <div className="flex flex-row items-center w-full justify-end">
                  <FinanceManagerSelector
                    id={deal.id}
                    value={deal.finance_manager}
                    hideName
                  />
                </div> */}
                {/* <div className="flex flex-row items-center w-full justify-end">
                  <SalesRepSelectors
                    dealShortId={deal.short_id}
                    dealId={deal.id}
                    hideCopy
                    orientation="horizontal"
                    primarySalesRep={deal.primary_sales_rep}
                    secondarySalesRep={deal.secondary_sales_rep}
                    vehicle={deal.vehicle}
                    primaryCustomerFullName={deal.customer_name}
                  />
                </div> */}
              </div>
            </div>
            <div className="flex flex-row items-center gap-2 justify-start w-full">
              <div className="flex flex-row items-center w-full justify-start">
                {trade.year} {trade.make} {trade.model} {trade.trim}
              </div>
              {/* {deal.delivery_date && (
                <div
                  className="flex flex-row items-center border rounded-md"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                  }}
                >
                  <DeliveryDateSelector
                    delivery_date={deal.delivery_date}
                    dealId={deal.id}
                    hideIcon
                    hideYear
                    dateClassName="text-xs "
                    side="bottom"
                  />
                </div>
              )}
              {!isEmpty(assignedTasks) && (
                <div className="flex flex-row items-center gap-1 p-1 border rounded-md">
                  <TasksProgressRing assignedTasks={assignedTasks} />
                  <TasksFraction
                    assignedTasks={assignedTasks}
                    className="gap-0 text-xs "
                  />
                </div>
              )}
              <div
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <DealPrioritySelectorButton
                  id={deal.id}
                  value={deal.priority}
                  hideCopy
                  side="right"
                />
              </div> */}
            </div>
            <div className="flex flex-row items-center gap-2 justify-start w-full">
              <div className="flex flex-row items-center justify-between w-full">
                <div className="flex flex-row items-center gap-1">
                  <TradeCurrentLocationBadge
                    currentLocation={trade.current_location}
                  />
                </div>
                <div className="flex flex-row items-center justify-end">
                  {trade.appraised_value && (
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <div>
                          <CurrencyInput
                            value={centsToInitialValue(trade.appraised_value)}
                            placeholder="Appraisal Amount"
                            className="w-full text-right"
                            readOnly
                          />
                        </div>
                      </TooltipTrigger>
                      <TooltipContent>
                        <div className="text-nowrap overflow-hidden text-ellipsis cursor-pointer">
                          {trade.appraised_value !== 0
                            ? 'Appraisal Amount'
                            : 'No Appraisal'}
                        </div>
                      </TooltipContent>
                    </Tooltip>
                  )}
                </div>
              </div>
            </div>
          </div>
        </a>
      </Card>
    </div>
  );
};

export default TradeInAppraisalCard;
